import { createApi } from "@reduxjs/toolkit/query/react";
import {
  baseQueryWithArgs,
  getQueryStringWithCreator,
} from "../utils/reduxHelper";

export const gmvForCreatorAPI = createApi({
  reducerPath: "gmvForCreatorAPI",
  baseQuery: baseQueryWithArgs,
  refetchOnFocus: true,
  endpoints: (builder) => ({
    getGmvForCreator: builder.query({
      query: ({ rewardId }) => ({
        url: getQueryStringWithCreator(
          `c/getGmvForCreator?reward_id=${rewardId}`
        ),
      }),
      transformResponse: (res) => res?.data,
    }),
  }),
});

export const { useGetGmvForCreatorQuery } = gmvForCreatorAPI;

export default gmvForCreatorAPI;
